module.exports = __webpack_public_path__ + "img/concours-asnl.075c089.png";